export default "__VITE_ASSET__D_UZa8Qu__"